import { Button } from '@/components/ui/button';
import { AlertTriangleIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ConfirmDialogProps {
    open: boolean;
    title: string;
    description: string;
    confirmLabel: string;
    onConfirm: () => void;
    onCancel: () => void;
    destructive?: boolean;
}

export default function ConfirmDialog({
    open,
    title,
    description,
    confirmLabel,
    onConfirm,
    onCancel,
    destructive = true,
}: ConfirmDialogProps) {
    const { t } = useTranslation();
    if (!open) return null;
    return (
        <div className="fixed inset-0 bg-[#1c2620]/40 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="bg-white rounded-lg border border-[#dadbd5] shadow-xl max-w-md w-full mx-4 overflow-hidden">
                <div className="p-6">
                    <div className="flex items-start gap-4">
                        {destructive && (
                            <div className="flex-shrink-0 h-10 w-10 rounded-full bg-red-50 flex items-center justify-center">
                                <AlertTriangleIcon className="h-5 w-5 text-red-600" />
                            </div>
                        )}
                        <div className="flex-1">
                            <h3 className="text-base font-semibold text-[#1c2620]">
                                {title}
                            </h3>
                            <p className="text-sm text-[#5a6259] mt-1.5 leading-relaxed">
                                {description}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="bg-[#f8f9f6] px-6 py-3 flex gap-2 justify-end border-t border-[#ecede8]">
                    <Button variant="outline" onClick={onCancel}>
                        {t('Cancel')}
                    </Button>
                    <Button
                        onClick={onConfirm}
                        className={
                            destructive
                                ? 'bg-red-600 hover:bg-red-700 text-white'
                                : 'bg-[#2d6a4f] hover:bg-[#245741] text-white'
                        }
                    >
                        {confirmLabel}
                    </Button>
                </div>
            </div>
        </div>
    );
}
